import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { useMessagesStore } from '@/stores/messages'

export const useApiClientsStore = defineStore('apiClients', {
  state: () => ({
    apiClients: []
  }),

  actions: {
    async fetch() {
      this.fetchInitiated = true

      return httpClient.get('/api/internal/api_clients')
        .then(response => {
          this.apiClients = response.data.api_clients
        })
        .catch((err) => {
          useMessagesStore().smartAdd(err)
        })
    },

    async destroy(apiClientId) {
      return httpClient.delete(`/api/internal/api_clients/${apiClientId}`)
        .then(() => {
          this.apiClients = this.apiClients.filter(apiClient => apiClient.id !== apiClientId)
        })
        .catch((err) => {
          useMessagesStore().smartAdd(err)
        })
    }
  }
})
